export const PARENT_TABS = [
	{ id: 'updates', label: 'Configured updates', iconKey: 'updatesTab' },
	{ id: 'contacts', label: 'Contacts', iconKey: 'contactsTab' },
	{ id: 'logs', label: 'Logs', iconKey: 'logsTab' },
]

export const CONTACT_TYPE_LABELS = {
	parent: 'Parent',
	guardian: 'Guardian',
	emergency_contact: 'Emergency contact',
}

export const SUMMARY_ITEMS = [
	{ id: 'active', label: 'Active updates', iconKey: 'toggleOn', valueKey: 'activeCount' },
	{ id: 'paused', label: 'Paused updates', iconKey: 'pauseCircle', valueKey: 'pausedCount' },
]

export const RULE_LIST_COLUMNS = ['Update', 'Status']

export const DEFAULT_TEMPLATE_ICON_KEY = 'drafts'

/** Decorative icon key for API notification codes (not user-facing copy). */
export const API_NOTIFICATION_ICON_BY_CODE = {
	essay_updates: 'personal_statement',
	deadline_alerts: 'deadline_reminder',
	application_milestones: 'roadmap_ready',
	test_scores: 'psychology_alt',
	general_updates: 'getting_started',
}
